import React from "react";
import { useHistory } from "react-router-dom";

const Footer = () => {
  const history = useHistory();

  return (
    <footer className="bg-light p-3 text-center">
      <div className="logo" style={{position: 'relative', left: '10px', cursor: 'pointer'}} onClick={() => history.push('/')} />
      <small>
        Made with&nbsp;❤️&nbsp; from CoinDogg
      </small>
    </footer>
  );
}

export default Footer;
